import { useTranslation } from "react-i18next";
import Logo from "../../icons/logo.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import { DropDirection } from "../../types/constants";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { contactsServiceFactory } from "../../services/ContactsServiceImpl";

const contactsService = contactsServiceFactory();

const footerLinksColumn1 = [
    { titleKey: "home.footerLinks.column1.0", href: "/about" },
    { titleKey: "home.footerLinks.column1.1", href: "/news" },
    // { titleKey: "home.footerLinks.column1.2", href: "/projects" },
    // { titleKey: "home.footerLinks.column1.3", href: "/events" },
];

const footerLinksColumn2 = [
    { titleKey: "home.footerLinks.column2.0", href: "/educational-materials" },
    // { titleKey: "home.footerLinks.column2.1", href: "/forum" },
    // { titleKey: "home.footerLinks.column2.2", href: "/cooperation" },
    // { titleKey: "home.footerLinks.column2.3", href: "/account" },
];

const FooterLinksColumn = ({ items }: { items: { titleKey: string; href: string }[] }) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col gap-[24px]">
            {items.map((item, index) => (
                <Link
                    key={index}
                    to={item.href}
                    className="text-base font-normal text-text-300 transition-colors duration-300 hover:text-primary-400"
                >
                    {t(item.titleKey)}
                </Link>
            ))}
        </div>
    );
};

const FooterContactsBlock = () => {
    const { t, i18n } = useTranslation();
    const { data: contacts } = useQuery({
        queryKey: ["contacts", i18n.language],
        queryFn: async () => await contactsService.getContacts(),
    });

    return (
        <div className="flex flex-col gap-[6px] text-base font-normal text-text-700">
            <div>{contacts?.email || t("home.contacts.emailText")}</div>
            <div>{contacts?.phone || t("home.contacts.phoneText")}</div>
            <div>{contacts?.address || t("home.contacts.addressText")}</div>
        </div>
    );
};

// const NewsletterForm = () => {
//     const { t } = useTranslation();
//     return (
//         <div className="flex flex-col justify-start">
//             <div className="w-full font-normal text-base text-text-700 mb-[24px]">{t("home.newsletter.title")}</div>
//             <div className="w-full h-[46px] flex">
//                 <div className="flex-1 h-full flex items-center px-[20px] bg-background-100 border border-border-400 rounded-l-[4px]">
//                     <span className="text-base font-normal text-text-300">{t("home.newsletter.placeholder")}</span>
//                 </div>
//                 <button
//                     type="button"
//                     className="w-[140px] h-full flex items-center justify-center bg-background-400 border border-primary-400 rounded-r-[4px] font-normal text-sm text-text-400 uppercase"
//                 >
//                     {t("home.newsletter.button")}
//                 </button>
//             </div>
//         </div>
//     );
// };

export default function FooterContacts() {
    return (
        <>
            {/* Десктоп (≥1280px) */}
            <div className="hidden xl:flex w-full h-[152px] justify-between items-start">
                <Link to="/">
                    <img src={Logo} alt="Logo" className="w-[68px] h-[67px] rounded-2xl object-cover" />
                </Link>

                <FooterContactsBlock />

                <div className="w-[313px] h-[152px] flex gap-[40px]">
                    <div className="w-[108px]">
                        <FooterLinksColumn items={footerLinksColumn1} />
                    </div>
                    <div className="w-[165px]">
                        <FooterLinksColumn items={footerLinksColumn2} />
                    </div>
                </div>

                <div className="w-[413px] h-[152px] flex flex-col">
                    {/* <NewsletterForm /> */}
                    <div /** className="mt-[38px]" */>
                        <LanguageSwitcher dropDirection={DropDirection.UP} dropdownRightOffset="" />
                    </div>
                </div>
            </div>

            {/* Mobile / Tablet (<1280px) */}
            <div className="flex flex-col gap-[40px] xl:hidden w-full">
                <div className="flex flex-col md:flex-row justify-between items-start gap-[53px] md:gap-0">
                    <Link to="/">
                        <img
                            src={Logo}
                            alt="Logo"
                            className="w-[57px] h-[56px] md:w-[89px] md:h-[87px] rounded-2xl object-cover"
                        />
                    </Link>
                    {/* <div className="w-full md:w-[413px]">
                        <NewsletterForm />
                    </div> */}
                </div>

                <div className="flex flex-col gap-[40px]">
                    <div className="flex flex-col md:flex-row gap-[53px] md:gap-[107px]">
                        <div className="flex flex-row gap-[60px]">
                            <div className="min-w-[108px]">
                                <FooterLinksColumn items={footerLinksColumn1} />
                            </div>
                            <div className="min-w-[165px]">
                                <FooterLinksColumn items={footerLinksColumn2} />
                            </div>
                        </div>

                        <div className="w-[248px] md:min-w-[248px]">
                            <FooterContactsBlock />
                            <div className="mt-[53px] md:mt-[24px]">
                                <LanguageSwitcher dropDirection={DropDirection.UP} dropdownRightOffset="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
